import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import styles from './styles';

const UTRadioButton = ({ onPress, selected, style, label, subText }) => {
  const styleVar = selected ? styles.selected : {};
  return (
    <div style={[styles.container, style]}>
      <UTTouchableWithoutFeedback onClick={onPress} style={{ ...styles.outerBorder, ...styleVar }}>
        {selected ? <div style={styles.innerDot} /> : null}
      </UTTouchableWithoutFeedback>
      <UTTouchableWithoutFeedback style={styles.textContainer} onClick={onPress}>
        {label ? (
          <UTLabel darkGray small style={styles.text}>
            {label}
          </UTLabel>
        ) : null}
        {subText && (
          <UTLabel small style={styles.subText}>
            {subText}
          </UTLabel>
        )}
      </UTTouchableWithoutFeedback>
    </div>
  );
};

UTRadioButton.propTypes = {
  label: PropTypes.string,
  subText: PropTypes.string,
  onPress: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  style: PropTypes.any // eslint-disable-line react/forbid-prop-types
};

export default Radium(UTRadioButton);
